import { render } from "./informedConsentView.vue?vue&type=template&id=4e07edf4&scoped=true"
import script from "./informedConsentView.vue?vue&type=script&lang=js"
export * from "./informedConsentView.vue?vue&type=script&lang=js"

import "./informedConsentView.vue?vue&type=style&index=0&id=4e07edf4&lang=less&scoped=true"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e07edf4"]])

export default __exports__